<template>
    <div class="login">
        <a-row>
            <a-col :span="12">
                <div style="display:inline-block;margin-left:360px;width:500px;margin-top:150px;float:left">
                    <div style="color:rgba(18, 18, 18, 1);font-size:32px;font-weight:bold;">小文智能服务商后台</div>
                    <div style="color:rgba(18, 18, 18, 1);font-size:14px;margin:41px 0 0 0">您可登录服务商后台，完成用户管理，订单审批，账单管理，商品发布等功能</div>
                    <div>
                        <img style="width:520px;" src="../../assets/img/login-img.png" alt="">
                    </div>
                </div>
            </a-col>
            <a-col :span="12">
                <div style="width:360px;height:440px;background:#fff;box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.12);;display:inline-block;float:left;margin:200px 100px 200px 0;position:relative;margin-left:80px">
                    <a-tabs v-if="currentState==1" default-active-key="1" style="height:100%;">
                        <a-tab-pane key="1" tab="账号密码登录" force-render>
                            <div style="padding:80px 40px 0">
                                <a-input v-model="loginPwd.phone" style="height:40px;border:none;background:rgba(240, 242, 243, 0.5)" placeholder="请输入手机号" />
                                <a-input type="password" v-model="loginPwd.password" style="height:40px;border:none;background:rgba(240, 242, 243, 0.5);margin-top:21px;" placeholder="请输入密码" />
                                <a-button @click="loginInPwd" style="margin-top:25px;width:100%;height:40px;" type="primary">
                                登录
                                </a-button>
                                <!-- <div @click="goRegister" style="color:rgba(153, 153, 153, 1);font-size:14px;cursor:pointer;text-decoration:underline;position:absolute;right:39px;bottom:80px;">没有账号，去注册</div> -->
                            </div>
                        </a-tab-pane>
                        <a-tab-pane key="2" tab="手机号登录">
                            <div style="padding:80px 40px 0">
                                <a-input v-model="loginMessage.bindedPhoneNum" style="height:40px;border:none;background:rgba(240, 242, 243, 0.5)" placeholder="请输入手机号" />
                                <div style="margin-top:21px;height:40px">
                                    <VerificationCode v-bind:message="loginMessage" ref='loginCode'></VerificationCode>
                                </div>
                                <a-button @click="loginInPhone" style="margin-top:25px;width:100%;height:40px;" type="primary">
                                登录
                                </a-button>
                                <!-- <div @click="goRegister" style="color:rgba(153, 153, 153, 1);font-size:14px;cursor:pointer;text-decoration:underline;position:absolute;right:39px;bottom:80px;">没有账号，去注册</div> -->
                            </div>
                        </a-tab-pane>
                       
                    </a-tabs>
                    <div v-if="currentState==2">
                        <div style="height:48px;border-bottom:1px solid rgba(229, 229, 229, 1);line-height:48px;color:rgba(18, 18, 18, 1);font-size:14px;padding-left:24px;font-weight:bold;">
                            手机号快速注册
                        </div>
                        <div style="padding:80px 40px 0">
                            <div v-if="currentRegisterState==1">
                                <a-input v-model="registerMessage.bindedPhoneNum" style="height:40px;border:none;background:rgba(240, 242, 243, 0.5)" placeholder="请输入手机号" />
                                <div style="margin-top:21px;height:40px">
                                    <VerificationCode v-bind:message="registerMessage" ref='registerCode'></VerificationCode>
                                </div>
                                <a-button @click="nextStep" style="margin-top:25px;width:100%;height:40px;" type="primary">
                                下一步
                                </a-button>
                                <div @click="goLogin" style="color:rgba(153, 153, 153, 1);font-size:14px;cursor:pointer;text-decoration:underline;position:absolute;right:39px;bottom:80px;">已有账号，去登录</div>
                            </div>
                            <div v-if="currentRegisterState==2">
                                <a-input v-model="companyName" style="height:40px;border:none;background:rgba(240, 242, 243, 0.5)" placeholder="请输入公司名称" />
                                <a-button @click="doRegister" style="margin-top:25px;width:100%;height:40px;" type="primary">
                                注册
                                </a-button>
                                <div @click="offRegister" style="color:rgba(153, 153, 153, 1);font-size:14px;cursor:pointer;text-decoration:underline;position:absolute;right:39px;bottom:80px;">取消</div>
                            </div>
                            <div v-if="currentRegisterState==3">
                                <div style="text-align:center;color:rgba(10, 191, 91, 1);margin-bottom:16px;">
                                    <!-- <a-icon type="check-circle" /> -->
                                    <img src="../../assets/img/register-success.png" alt="">
                                </div>
                                <div style="text-align:center;color:rgba(10, 191, 91, 1);font-size:16px;">注册成功</div>
                                <div @click="goLogin" style="color:rgba(153, 153, 153, 1);font-size:14px;cursor:pointer;text-decoration:underline;position:absolute;right:39px;bottom:80px;">已有账号，去登录</div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </a-col>
        </a-row>
        
        

    </div>
</template>

<script>
import VerificationCode from '../../components/VerificationCode'
export default {
    name: 'Login',
    props: {
        msg: String
    },
    components: {VerificationCode},
    data() {
        return {
            currentState: 1,
            currentRegisterState: 1,
            registerMessage: {
                bindedPhoneNum: '',
                type: 2
            },
            loginMessage: {
                bindedPhoneNum: '',
                type: 4
            },
            companyName: '',
            loginPwd: {
                phone: '',
                password: ''
            },
            appInfo: '',
            appId: ''
        }
    },
    methods: {
        goRegister() {
            this.currentState = 2
            this.currentRegisterState = 1
        },
        goLogin() {
            this.currentState = 1
        },
        nextStep() {
            this.currentRegisterState = 2
        },
        doRegister() {
            this.currentRegisterState = 3
        },
        offRegister() {
            this.currentRegisterState = 1
        },
        loginInPhone() {
            this.axios.post('/api/login/phone/verifyCode', {
                phone: this.loginMessage.bindedPhoneNum,
                verifyCode: this.$refs.loginCode.verificationCode,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.sessionData('set','token',response.data.data.token)
                    this.sessionData('set','currentTab',2);
                    this.$router.push("/Coordination")
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        loginInPwd() {
            this.axios.post('/api/login/phone/password', {
                phone: this.loginPwd.phone,
                password: this.loginPwd.password,
            })
            .then(response=> {
                if(response.data.code == 0){
                    localStorage.setItem('username', this.loginPwd.phone);
                    localStorage.setItem('password', this.loginPwd.password);
                    this.sessionData('set','token',response.data.data.token)
                    this.sessionData('set','currentTab',2);
                    this.$router.push("/Coordination")
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        queryBasicData() {
            this.axios(
                {
                    method:'get',
                    url:'/api/app/loginInfo', 
                    params: {
                        appId: this.appId,
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.appInfo = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        }
    },
    mounted: function() {
        // this.queryBasicData()
    },
    created() {
        // 在组件创建时读取上次输入的账号和密码
        this.loginPwd.phone = localStorage.getItem('username') || '';
        this.loginPwd.password = localStorage.getItem('password') || '';
    },
}
</script>

<style scoped lang="less"> 
    .login{
        height: 100%;
        background:url('../../assets/img/bg.png') no-repeat;    
        background-size: 100% 100%;
    }
</style>
